export default {"src":"/_next/static/media/help.d89d4487.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};